"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapping = require("@nicbase/mapping");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getMovingState = function getMovingState(status) {
  return status.some(function (state) {
    return state === 'DRIVING';
  }) ? 'DRIVING' : 'STANDING';
};

var TourDataViewAsset = function TourDataViewAsset(_ref) {
  var className = _ref.className,
      assetName = _ref.assetName,
      assetType = _ref.assetType,
      latestDataStatus = _ref.latestDataStatus;
  var moveState = getMovingState(latestDataStatus.map(function (status) {
    return status.type;
  }));
  var AssetIcon = (0, _mapping.assetToIcon)(assetType, moveState);

  if (AssetIcon) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex align-self whitespace-nowrap', className)
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: (0, _mapping.assetToTranslation)(assetType)
    }, function (title) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        title: title
      }, /*#__PURE__*/_react["default"].createElement(AssetIcon, null));
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "ml-2 font-bold"
    }, assetName));
  }

  return null;
};

TourDataViewAsset.propTypes = {
  className: _propTypes["default"].string,
  assetName: _propTypes["default"].string,
  assetType: _propTypes["default"].number.isRequired,
  latestDataStatus: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
};
TourDataViewAsset.defaultProps = {
  className: '',
  assetName: '',
  latestDataStatus: []
};
var _default = TourDataViewAsset;
exports["default"] = _default;